import { useCallback } from 'react';
import { userSelector } from 'redux/selectors';
import { useSelector } from 'react-redux';

export const useSocialAuth = (isInvite) => {
  const currentUser = useSelector(userSelector);

  return useCallback(
    (user) => {
      // Only enforce the match when we actually hold the invited user. After a full reload of
      // /mfa/verify, Redux no longer has it (currentUser is undefined); treating that absence
      // as a mismatch would falsely block valid invite logins. The backend still binds the
      // challenge token to the authenticated account, so skipping here doesn't open a hole.
      if (isInvite && currentUser?.id && currentUser.id !== user?.id) {
        const message = `This invite is for ${currentUser.email}, but you used ${user.email}.\n\nTo continue, use Google/LinkedIn with ${currentUser.email} or continue with email to set a password.`;
        const error = new Error(message);
        error.status = 401;
        error.isInviteMismatch = true;
        error.data = {
          error: message,
        };
        throw error;
      }
    },
    [currentUser, isInvite],
  );
};
